exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-body,\n.panel .list-group,\n.panel [uib-tabset] {\n\tfont-size: 16px;\n}\n\n.panel-title {\n\tmax-width: 100%;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.panel-title i {\n\tfont-size: 24px;\n\tvertical-align: middle;\n\ttext-decoration: none !important;\n\tmargin-right: 5px;\n\tmargin-top: -3px;\n}\n", ""]);

// exports
